/* eslint-disable @typescript-eslint/no-require-imports */
/* eslint-disable @typescript-eslint/no-var-requires */

export function MonkeyPatchLeaflet(): void {
  (function leafletPatching(): void {
    const leaflet = require('leaflet');
    require('leaflet-draw');
    require('leaflet-editable');
    require('react-leaflet');
    const { CircleMarkerEditorEx } = require('./__legacy__/modules/annotation/components/DrawControl.models/CircleMarkerEditorEx');
    const { PolygonEditorEx } = require('./__legacy__/modules/annotation/components/DrawControl.models/PolygonEditorEx');
    const { PolylineEditorEx } = require('./__legacy__/modules/annotation/components/DrawControl.models/PolylineEditorEx');
    const { initPathDrag } = require('./__legacy__/modules/annotation/components/DrawControl.models/PathDrag');
    require('leaflet-path-transform');
    leaflet.Editable.CircleMarkerEditor = CircleMarkerEditorEx;
    leaflet.Editable.PolygonEditor = PolygonEditorEx;
    leaflet.Editable.PolylineEditor = PolylineEditorEx;
    initPathDrag();
  })();
}
